import React, {Fragment} from 'react';
import EditorField from "./editor/editor";
import {exportToMustache, importFromMustache} from "./editor/ContentFormatter";
import classNames from "classnames";
import strip_tags from "locutus/php/strings/strip_tags";

export default class Tags extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <EditorField
                    {...this.props}
                    className={classNames("rt-rich-tags", this.props.oneLine ? "one-line" : "")}
                    toolbar={['variable']}
                    disableNewLine={this.props.oneLine}
                    placeholder={this.props.placeholder}
                    import={(value) => importFromMustache('<editor>' + strip_tags(value) + '</editor>')}
                    export={(html) => strip_tags(exportToMustache(html))}
                />
            </Fragment>
        );
    }
}